<template>
    
    <div class="row">
        <div class="col">
            <div class="card page-card">

                <div class="card-header d-flex align-items-center justify-content-between">
                    <div class="title">
                        <i class="fa fa-align-justify mr-2"></i> 
                        {{trans.title}}
                    </div>

                    <div class="action-buttons">
                        <a target="_blank" :href="getPdfLinkUrl()" class="btn btn-dark">
                            <i class="fal fa-fw fa-file-pdf mr-1"></i> <span class="hidden-sm-down">{{trans.print}} (PDF)</span>
                        </a>
                    </div>
                </div>

                <div class="card-block" style="min-height: calc(100vh - 140px);" v-cloak>
                    <form @submit.prevent="">
                        <div class="row justify-content-between">
                            <div class="col col-10 col-lg-9 col-xl-7 form-group compact">

                                <div class="input-group">
                                    <multiselect v-model="filters.type"
                                                    @close="refreshData()"
                                                    :options="filterTypesOptions"
                                                    label="label"
                                                    track-by="id"
                                                    :allow-empty="false"
                                                    :close-on-select="true"
                                                    :searchable="false"
                                                    :select-label="''"
                                                    :deselect-label="''"
                                                    :selected-label="''"
                                                    class="mr-2"
                                                    style="max-width: 140px; min-width: 130px;">
                                    </multiselect>
                                    
                                    <multiselect
                                        v-model="filters.scope"
                                        @close="refreshData()"
                                        :options="filterScopesOptions"
                                        label="label"
                                        track-by="id"
                                        :allow-empty="false"
                                        :close-on-select="true"
                                        :searchable="false"
                                        :select-label="''"
                                        :deselect-label="''"
                                        :selected-label="''"
                                        style="max-width: 380px; min-width: 200px;">
                                    </multiselect>

                                    <div class="col mb-0 form-group">
                                        <div class="input-group">
                                            <button type="button" v-if="isFiltered()" class="btn btn-danger" @click="resetFilter(); filter()">
                                                <i class="fa fa-trash-alt"></i> <span class="hidden-sm-down">{{ trans.btn.delete_filter }}</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group ml-auto pr-3">

                                <dropdown-months
                                    :trans="transMonths"
                                    :year-count="5"
                                    :year="year"
                                    :month="month"
                                    :choose-action="chooseMonth"
                                    :loading="loading"
                                    :show-buttons="true"
                                />
                                
                            </div>

                        </div>
                    </form>
                    
                    <div class="loading-box" v-if="loading">
                        <div class="loading-inner"><i class="fa fa-spin fa-circle-notch text-secondary"></i></div>
                    </div>
                    
                    <div class="table-responsive table-scrollable" v-if="!loading">
                        <table class="table table-hover">
                            <thead>
                                <tr>
                                    <th column="type">{{trans.columns.type.title}}</th>
                                    <th column="date">{{trans.columns.date}}</th>
                                    <th is='sortable' column="wage_personal_number">{{trans.columns.wage_personal_number}}</th>
                                    <th is='sortable' column="last_name">{{trans.columns.name}}</th>
                                    <th is='sortable' column="contract_type">{{trans.columns.contract_type}}</th>
                                    <th column="latest_contract">{{trans.columns.latest_contract}}</th>
                                    <th column="first_contract">{{trans.columns.first_contract}}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            
                            <tbody>
                                <tr v-for="(item, index) in items" :key="index">
                                    <td><b-badge :variant="getItemBadgeVariant(item)"><i class="fa fa-fw text-white" :class="getItemClass(item)"></i>&nbsp;{{item.type_label}}</b-badge></td>
                                    <td>{{item.date}}</td>
                                    <td>{{item.wage_personal_number}}</td>
                                    <td>{{item.last_name}} {{item.first_name}}</td>
                                    <td>{{item.contract_type}}</td>
                                    <td>{{item.interval_start}} - <span v-if="item.interval_end != null">{{item.interval_end}}</span><span v-else>...</span></td>
                                    <td>{{item.first_start}}</td>
                                    <td><a class="btn btn-sm btn-spinner btn-success" target="_blank" :href="item.resource_url"><i class="far fa-fw fa-user"></i></a></td>
                                </tr>
                            </tbody>
                            
                            <tfoot v-if="items.length == 0">
                                <tr>
                                    <td colspan="8">
                                        <div class="text-center d-flex align-items-center justify-content-center" style="height: 80px;"><i>{{ trans.empty_data_msg }}</i></div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppListing from '../../app-components/Listing/AppListing'

export default {
    name: "ReportStartTerminationContracts",
    mixins: [AppListing],
    props: {
        'baseUrl': {
            type: String
        },
        'avalaibleMonths': {
            type: Array,
            default() {
                return [];
            }
        },
        'selectedMonth': {
            type: Object,
            default() {
                return null;
            }
        },
        'trans': { 
            type: Object 
        },
        'transMonths': {
            type: Object
        },
        'filterScopesOptionsList': {
            type: Array,
            default() {
                return [
                    { 'id': 'edge_cases_only', 'label': this.trans.filter_type_labels.edge_cases_only },
                    { 'id': 'contract_type_changes', 'label': this.trans.filter_type_labels.contract_type_changes },
                    { 'id': 'all_intervals_changes', 'label': this.trans.filter_type_labels.all_intervals_changes }
                ];
            }
        },
        'filterTypesOptionsList': {
            type: Array,
            default() {
                return [
                    { 'id': '', 'label': this.trans.columns.type.all },
                    { 'id': 'start', 'label': this.trans.columns.type.start },
                    { 'id': 'end', 'label': this.trans.columns.type.end }
                ];
            }
        }
    },
    data() {
        return {
            filters: {
                type: this.filterTypesOptionsList[0],
                scope: this.filterScopesOptionsList[0] // default value
            },
            filterScopesOptions: this.filterScopesOptionsList,
            filterTypesOptions: this.filterTypesOptionsList,
            loading: true,
            items: [],
            selectedMonthMutable: {},
            orderBy: {
                column: 'last_name',
                direction: 'asc'
            },
            initSetDataComplete: false,
            mutableUrl: '',
            dateUrlPath: '',
            startOfMonth: '',
            endOfMonth: '',
            year: null,
            month: null
        };
    },

    created() {
        this.year = Number( moment(this.selectedMonth.key).format('YYYY') );
        this.month = Number( moment(this.selectedMonth.key).format('MM') );

        this.selectedMonthMutable = this.selectedMonth.key;
        this.mutableUrl = this.url;

        this.startOfMonth =  moment(this.selectedMonth.key, "YYYY-MM").startOf('month').format("YYYY-MM-01 00:00:00");
        this.endOfMonth =  moment(this.selectedMonth.key, "YYYY-MM").endOf('month').format("YYYY-MM-DD 23:59:59");

        const momentSelectedMonth = moment(this.selectedMonth.key, "YYYY-MM");
        this.dateUrlPath = momentSelectedMonth.format("YYYY")+"/"+momentSelectedMonth.format("MM");

        this.$nextTick(function () {
            this.initSetDataComplete = true;
        });
    },

    methods: {
        chooseMonth(year, month) {
            this.selectedMonthMutable = year+"-"+(month < 10 ? "0":"")+month;

            this.year = year;
            this.month = month;

            const momentDate = moment(this.selectedMonthMutable, "YYYY-MM");

            this.dateUrlPath = momentDate.format("YYYY/MM");
            this.startOfMonth =  momentDate.startOf('month').format("YYYY-MM-01 00:00:00");
            this.endOfMonth =  momentDate.endOf('month').format("YYYY-MM-DD 23:59:59");

            this.mutableUrl = this.baseUrl+"/"+this.dateUrlPath;

            this.refreshData();
        },

        getFilterableUrl(withoutBase) {
            return withoutBase ? '' : this.mutableUrl;
        },

        refreshData() {
            if(this.initSetDataComplete) {
                if(window.history.replaceState) {
                    window.history.replaceState({}, null, this.getFilterableUrl());
                }

                this.loadData();
            }
        },

        loadData() {
            this.loading = true;

            let data = {
                params: {
                    type: this.filters.type.id,
                    scope: this.filters.scope.id,
                    orderBy: this.orderBy.column,
                    orderDirection: this.orderBy.direction
                }
            };

            axios.get(this.mutableUrl, data)
                .then(response => {
                    this.items = response.data;
                    this.loading = false;
                })
                .catch(error => {});
        },
        
        getPdfLinkUrl()
        {
            let typeFilter = (this.filters.type ? this.filters.type.id : '');
            let scopeFilter = (this.filters.scope ? this.filters.scope.id : '');
            
            return this.mutableUrl + '/export?type='+typeFilter+'&scope='+scopeFilter+'&orderBy='+this.orderBy.column+'&orderDirection='+this.orderBy.direction;
        },
        
        getItemClass(item)
        {
            return (item.type=='start' ? 'fa-sign-in-alt' : 'fa-sign-out-alt');
        },

        getItemBadgeVariant(item)
        {
            return (item.type=='start' ? 'success' : 'danger');
        },

        resetFilter() {
            this.filters.type=this.filterTypesOptionsList[0],
            this.filters.scope=this.filterScopesOptionsList[0]; 
        },
        
        isFiltered() {
            if(this.filters.type != this.filterTypesOptionsList[0] || this.filters.scope != this.filterScopesOptionsList[0])
            {
                return 1;
            } 
            else
            {
                return 0;
            }            
        },
    }

}
</script>



// WEBPACK FOOTER //
// resources/assets/admin/js/report/in-out-contracts-report/ReportInOutContracts.vue